import React from 'react';
import { RightOutlined } from '@ant-design/icons';

import { getRouteStackPath } from '@portal/config/routes';
import { useNavigation } from '@portal/hooks/useNavigation';
import { translate } from '@portal/services/i18n';

import './ChangeTaxIdentifierButton.less';

const ChangeTaxIdentifierButton: React.FC = () => {
  const navigate = useNavigation();

  return (
    <button
      type="button"
      className="change-tax-identifier-button"
      onClick={() => navigate(getRouteStackPath('AUTH', 'REGISTER'))}
    >
      {translate('PAGES.AUTH.REGISTER.ONBOARD.CHANGE_TAX_IDENTIFIER')}
      <RightOutlined />
    </button>
  );
};

export default ChangeTaxIdentifierButton;
